function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

const autoSlideout = () => {
  const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
  if (scrollTop > 850) {
    const slideoutContainer = document.getElementById('slideout_container');
    if (slideoutContainer !== null && !slideoutContainer.classList.contains('open') && !slideoutContainer.classList.contains('dismiss')) {
      slideoutContainer.classList.add('open');
      slideoutContainer.classList.add('dismiss');
      setCookie('br-slideout-dismiss', 'yes', 1);
    }
  }
}

const toggleSlideout = () => {
  document.getElementById('slideout_container').classList.toggle('open');
}

window.addEventListener('load', function () {
  if (Foundation.MediaQuery.atLeast('medium')) {
    const slideout = document.getElementById('slideout_button');
    if (slideout) {
      window.addEventListener('scroll', autoSlideout);
      slideout.addEventListener('click', toggleSlideout);
    }
  }
}, false);
